// src/pulseadmin/PulseAdmin.js
import React, { useState, useEffect } from "react";
import { getFunctionOptions } from "shared/api/function_data";

function PulseAdmin() {
  const [functionOptions, setFunctionOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getFunctionOptions();
        
        if (Array.isArray(data)) {
          setFunctionOptions(data);
        } else if (typeof data === 'object') {
          setFunctionOptions(Object.values(data));
        }
      } catch (err) {
        setError(err.message || "Failed to load function options");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {/* Your PulseAdmin component using functionOptions */}
      {functionOptions.map((option) => (
        <div key={option.id}>
          {option.label} - {option.description}
        </div>
      ))}
    </div>
  );
}

export default PulseAdmin;